module.exports = __webpack_public_path__ + "img/knowledge.5931ed02.svg";